/* 产引入jsencrypt实现数据RSA加密 */
//import JSEncrypt from "jsencrypt"; // 处理长文本数据时报错 jsencrypt.js Message too long for RSA
/* 产引入encryptlong实现数据RSA加密 */
import Encrypt from "encryptlong"; // encryptlong是基于jsencrypt扩展的长文本分段加解密功能。
import axios from "axios";
// 密钥对生成 http://web.chacuo.net/netrsakeypair
export default {
  // 获取令牌
  getKey(url) {
    return axios.get(url);
  },
  /* JSEncrypt加密 */
  getPublicKey() { },
  /* rsaPublicData(data) {
    var jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(publicKey);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data);
    return result;
  }, */
  /* JSEncrypt解密 */
  /* rsaPrivateData(data) {
    var jsencrypt = new JSEncrypt();
    jsencrypt.setPrivateKey(privateKey);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data);
    return result;
  }, */
  /* 加密 */

  encrypt(data, key) {
    const PUBLIC_KEY = key;
    var encryptor = new Encrypt();
    encryptor.setPublicKey(PUBLIC_KEY);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    const result = encryptor.encryptLong(data);
    return result;
  },
  /* 解密 - PRIVATE_KEY - 验证 */
  decrypt(data, key) {
    const PRIVATE_KEY = key;
    var encryptor = new Encrypt();
    encryptor.setPrivateKey(PRIVATE_KEY);
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = encryptor.decryptLong(data);
    return result;
  }
};
